import { Component, OnInit } from '@angular/core';
import { Yii } from 'libraries/interfaces/Yii';
import { FormControl, FormGroup, FormGroupDirective } from "@angular/forms";
import { Keywords } from "libraries/interfaces/i-post-air-search-request";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { EAirSearchFields } from "app_locobook/air-search/e-air-search-fields";

export const keywordList: IMultiselectOptions[] = [
    {label: Yii.t('wui-shared-js', 'Bagages enregistrés'), value: Keywords.luggageInHold},
];

class Wording {
    public readonly servicesIncluded: string = Yii.t('wui-shared-js', 'Services Inclus');
    public readonly select: string = Yii.t('wui-shared-js', 'Sélectionner');
}

@Component({
    selector: 'air-search-keyword-form',
    templateUrl: './air-search-keyword-form.component.html',
    styleUrls: ['./air-search-keyword-form.component.scss']
})
export class AirSearchKeywordFormComponent implements OnInit {
    public airKeywordSearchForm: FormControl;
    public wording: Wording = new Wording();
    public keywordList: IMultiselectOptions[] = keywordList;
    public airSearchForm: FormGroup;

    constructor(
        private readonly formGroupDirective: FormGroupDirective,
    ) { }

    public ngOnInit(): void {
        this.initAirSearchKeywordForm();
    }

    private initAirSearchKeywordForm(): void {
        this.airKeywordSearchForm = new FormControl();
        this.airSearchForm = this.formGroupDirective.form;
        this.airSearchForm.addControl(EAirSearchFields.keyword, this.airKeywordSearchForm);
    }
}
